import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { NewReviewModalContentContainer } from '../NewReviewModalContent';
import { NewReviewModalFooterContainer } from '../NewReviewModalFooter';
import { getIsOpen, selectNewReviewFormStep } from '../../selectors/newReview';
import { setNewReviewFormClose } from '../../actions/newReview';
import { getIsAgent } from '../../selectors/user';
import { RejectionForBuilder } from '../../components/RejectionForBuilder';
import { FormModalLayout } from '../../components/FormLayout';
import { getObjectInfo } from '../../selectors/objectInfo';
import { ENewReviewStep } from '../../types/newReview';
import { TThunkDispatch } from '../../types/redux';

export const NewReviewModalContainer: React.FC<{}> = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isOpened = useSelector(getIsOpen);
  const step = useSelector(selectNewReviewFormStep);
  const isInfoLayout = step === ENewReviewStep.Error || step === ENewReviewStep.Success;
  const isAgent = useSelector(getIsAgent);
  const { objectName } = useSelector(getObjectInfo);

  const onClose = React.useCallback(() => {
    dispatch(setNewReviewFormClose());
  }, [dispatch]);

  if (isAgent) {
    return (
      <FormModalLayout
        testId="RejectionForBuilder"
        shortTitle="Новый отзыв"
        open={isOpened}
        onClose={onClose}
        type="info"
      >
        <RejectionForBuilder onClose={onClose} />
      </FormModalLayout>
    );
  }

  return (
    <FormModalLayout
      title={`Отзыв о ЖК «${objectName}»`}
      shortTitle="Новый отзыв"
      subtitle="Он появится на странице ЖК"
      footer={<NewReviewModalFooterContainer />}
      onClose={onClose}
      type={isInfoLayout ? 'info' : 'form'}
      open={isOpened}
      testId="NewReview"
    >
      <NewReviewModalContentContainer step={step} onClose={onClose} />
    </FormModalLayout>
  );
};
